<template>
  <div>
    <b-overlay :show="bShowLoading" rounded="sm">
      <b-row v-if="project" style="height:100%;">
        <!-- v-if="parentPath && path"  -->
        <b-col md="12" style="height:100%;">
          <!-- ITEM NO. -->
          <b-container>
            <b-row>
              <b-col md="6">
                <h5>{{ uniTranslation("PHE10179") }} / {{ uniTranslation("PHE10030") }}</h5>
              </b-col>
              <!--
          <b-col md="6" class="bordo" style="text-align:left">
            
            <p>{{ uniTranslation("PHE596") }}</p>
            
          </b-col>
          -->
            </b-row>
          </b-container>
          <br />
          <!-- PLATE H.E. Connections Incl. -->
          <b-container>
            <b-row>
              <b-col style="text-align:left">
                <h5>{{ uniTranslation("PHE10028") }}</h5>
              </b-col>
            </b-row>
            <b-row class="bordo">
              <b-col md="1" class="bordo-dx bordo-sotto">
                <input type="checkbox" style="margin-right:15px" disabled="true" checked />
              </b-col>
              <b-col md="9" class="bordo-dx bordo-sotto" style="text-align:left">
                <p v-text="uniTranslation(plateExchanger.desc1)"></p>
              </b-col>
              <b-col class="bordo-sotto" md="2" style="text-align:right">
                <b
                  v-if="$store.getters.profiloUtente.prezzi"
                  v-text="simboloValuta + ' ' + formatMoney(plateExchanger.prezzo)"
                ></b>
              </b-col>
              <b-col md="12">
                <b-row v-for="item in opzioni" v-if="item.combo" class="bordo-sotto">
                  <b-col
                    md=""
                    class="bordo-dx"
                    style="display: flex; align-content: center;flex-wrap: inherit;"
                  >
                    <input
                      v-model="item.ckd"
                      type="checkbox"
                      style="margin-right:15px"
                      :disabled="item.prezzoincluso"
                      @change="aggiornaPrezzoAccessori(item)"
                    />
                  </b-col>
                  <b-col md="9" class="bordo-dx">
                    <b-row>
                      <b-col
                        style="text-align:left; font-size: 13px;display: flex; align-content: center;flex-wrap: inherit;"
                        >{{
                          uniTranslation(item.desc1) +
                            uniTranslation(item.desc2) +
                            uniTranslation(item.desc3)
                        }}</b-col
                      >
                      <b-col v-if="item.combo" md="9" style="padding-right: 0px;">
                        <b-form-select
                          v-model="item.valoreSelezionato"
                          @change="SelectedCombo(item)"
                        >
                          <!--:options="item.listaValori"-->
                          <option
                            style="height: 100%"
                            v-for="vOpt in item.listaValori"
                            :value="vOpt.value"
                            >{{ controllaTesto(vOpt.text) }}</option
                          >
                        </b-form-select>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col md="2" style="display: flex; align-content: center;flex-wrap: inherit;">
                    <b
                      v-if="$store.getters.profiloUtente.prezzi"
                      style="text-align:right;width:100%"
                      v-text="simboloValuta + ' ' + formatMoney(item.prezzo)"
                    ></b>
                  </b-col>
                </b-row>
              </b-col>
              <b-col
                md="1"
                class="bordo-dx bordo-sotto"
                style="display: flex; align-content: center;flex-wrap: inherit;"
                v-show="stepPiastre.length > 0"
              >
                <input type="checkbox" style="margin-right:15px" v-model="bStepPiastre" />
              </b-col>
              <b-col
                md="8"
                class="bordo-sotto"
                style="text-align:left; font-size: 13px;display: flex; align-content: center;flex-wrap: inherit;"
                v-show="stepPiastre.length > 0"
              >
                <div>
                  <p>
                    {{ uniTranslation("TTL_STEPPIASTRE") }}
                  </p>
                  <p
                    v-show="bTelaioOriginale == false"
                    style="text-align:left; font-size: 13px;color: red"
                  >
                    {{ uniTranslation("TTL_POPUP_STEPPIASTRE") }}
                  </p>
                </div>
              </b-col>
              <b-col
                md="1"
                class="bordo-dx"
                style="padding-right: 0px;"
                v-show="stepPiastre.length > 0"
              >
                <b-form-select
                  style="height: 100%"
                  :disabled="bStepPiastre == false"
                  v-model="stepSelezionato"
                >
                  <!--:options="item.listaValori"-->
                  <option v-for="step in stepPiastre" :value="step">{{ step.percentuale }}%</option>
                </b-form-select>
              </b-col>
              <b-col
                md="2"
                style="display: flex; align-content: center;flex-wrap: inherit;"
                v-show="stepPiastre.length > 0"
              >
                <b style="text-align:right;width:100%" v-text="tradNrPiastreSuMassimo"></b>
              </b-col>
            </b-row>
          </b-container>
          <br />
          <!-- OPZIONI -->
          <b-container>
            <b-row v-if="$store.getters.profiloUtente.prezzi">
              <b-col style="text-align:left">
                <h5>{{ uniTranslation("PHE10029") }}</h5>
              </b-col>
            </b-row>
            <b-row v-else>
              <b-col style="text-align:left">
                <h5>{{ uniTranslation("PHE10179") }}</h5>
              </b-col>
            </b-row>
          </b-container>
          <b-container class="bordo">
            <b-row v-for="item in opzioni" v-if="item.combo == false" class="bordo-sotto">
              <b-col md="1" class="bordo-dx">
                <input
                  v-model="item.ckd"
                  type="checkbox"
                  style="margin-right:15px"
                  :disabled="item.prezzoincluso"
                  @change="aggiornaPrezzoAccessori(item)"
                />
              </b-col>
              <b-col md="9" class="bordo-dx" style="text-align:left">
                <b-row>
                  <b-col>{{
                    uniTranslation(item.desc1) +
                      uniTranslation(item.desc2) +
                      uniTranslation(item.desc3)
                  }}</b-col>
                  <b-col v-if="item.combo" md="9" style="padding-right: 0px;">
                    <b-form-select v-model="item.valoreSelezionato" @change="SelectedCombo(item)">
                      <!--:options="item.listaValori"-->
                      <option v-for="vOpt in item.listaValori" :value="vOpt.value">{{
                        controllaTesto(vOpt.text)
                      }}</option>
                    </b-form-select>
                  </b-col>
                </b-row>
              </b-col>
              <b-col v-if="$store.getters.profiloUtente.prezzi" md="2" style="text-align:right">
                <b v-text="simboloValuta + ' ' + formatMoney(item.prezzo)"></b>
              </b-col>
            </b-row>
          </b-container>
          <br />
          <!-- ACCESSORI -->
          <b-container>
            <b-row>
              <b-col style="text-align:left">
                <h5>{{ uniTranslation("PHE10030") }}</h5>
              </b-col>
            </b-row>
          </b-container>
          <b-container class="bordo">
            <b-row v-for="item in accessori" class="bordo-sotto">
              <b-col md="1" class="bordo-dx">
                <input
                  v-model="item.ckd"
                  type="checkbox"
                  style="margin-right:15px"
                  @change="aggiornaPrezzoAccessori(item)"
                />
              </b-col>

              <b-col v-if="!item.speciale" md="9" class="bordo-dx" style="text-align:left">{{
                uniTranslation(item.desc1)
              }}</b-col>
              <b-col
                v-if="$store.getters.profiloUtente.prezzi && !item.speciale"
                md="2"
                style="text-align:right"
              >
                <b v-text="simboloValuta + ' ' + formatMoney(item.prezzo)"></b>
              </b-col>

              <b-col v-if="item.speciale" md="9" class="bordo-dx" style="text-align:left">
                <input v-model="item.desc1" class="inputAcc" style="text-align:left;" />
              </b-col>

              <b-col
                v-if="$store.getters.profiloUtente.prezzi && item.speciale"
                md="2"
                style="text-align:right"
              >
                <input
                  v-model.number="item.prezzo"
                  type="number"
                  class="inputAcc"
                  style="text-align:right;"
                  @blur="AggiornaTotali()"
                />
              </b-col>
            </b-row>
          </b-container>
          <br />
          <!-- TOTALI -->
          <span v-if="$store.getters.profiloUtente.prezzi">
            <b-container>
              <b-row>
                <b-col md="4" style="text-align:left">
                  <h5>{{ uniTranslation("PHE10031") }}</h5>
                </b-col>
                <b-col md="3" style="text-align:right">
                  <h5>{{ uniTranslation("PHE10033") }}</h5>
                </b-col>
                <b-col md="2" style="text-align:center">
                  <h5>{{ uniTranslation("PHE10034") }}</h5>
                </b-col>
                <b-col md="3" style="text-align:right">
                  <h5>{{ uniTranslation("PHE10035") }}</h5>
                </b-col>
              </b-row>
            </b-container>
            <b-container class="bordo">
              <b-row class="bordo-sotto">
                <b-col md="4" class="bordo-dx" style="text-align:left">{{
                  //plateExchanger.desc1
                  uniTranslation("PHE10036")
                }}</b-col>
                <b-col
                  v-if="$store.getters.profiloUtente.prezzi"
                  md="3"
                  class="bordo-dx"
                  style="text-align:right"
                >
                  <b>{{ simboloValuta + " " + formatMoney(prezzoExchangerListino) }}</b>
                </b-col>
                <b-col md="2" class="bordo-dx">
                  <input
                    v-model.number="scontoExchanger"
                    value="0"
                    style="text-align:center;"
                    class="inputAcc"
                    @blur="validaScontoExchanger()"
                  />
                </b-col>
                <b-col v-if="$store.getters.profiloUtente.prezzi" md="3" style="text-align:right">
                  <b>
                    <input
                      v-model.number="prezzoExchangerNetto"
                      type="number"
                      class="inputAcc"
                      style="text-align:right;"
                      @blur="validaNettoExchanger()"
                    />
                  </b>
                </b-col>
              </b-row>
              <b-row class="bordo-sotto">
                <b-col md="4" class="bordo-dx" style="text-align:left">{{
                  uniTranslation("PHE10037")
                }}</b-col>
                <b-col
                  v-if="$store.getters.profiloUtente.prezzi"
                  md="3"
                  class="bordo-dx"
                  style="text-align:right"
                >
                  <b> {{ simboloValuta + " " + formatMoney(prezzoAccessoriListino) }}</b>
                </b-col>
                <b-col md="2" class="bordo-dx">
                  <input
                    v-model="scontoAccessori"
                    value="0"
                    style="text-align:center;"
                    class="inputAcc"
                    @blur="validaScontoAccessori()"
                  />
                </b-col>
                <b-col v-if="$store.getters.profiloUtente.prezzi" md="3" style="text-align:right">
                  <b>
                    <input
                      v-model.number="prezzoAccessoriNetto"
                      type="number"
                      class="inputAcc"
                      style="text-align:right;"
                      @blur="validaNettoAccessori()"
                    />
                  </b>
                </b-col>
              </b-row>
              <b-row>
                <b-col md="4" class="bordo-dx" style="text-align:left">
                  <b>{{ uniTranslation("PHE10038") }}</b>
                </b-col>
                <b-col
                  v-if="$store.getters.profiloUtente.prezzi"
                  md="3"
                  class="bordo-dx"
                  style="text-align:right"
                >
                  <b>{{ simboloValuta + " " + formatMoney(prezzoTotaleListino) }}</b>
                </b-col>
                <b-col md="2" class="bordo-dx">
                  <input
                    v-model="scontoTotale"
                    value="0"
                    style="text-align:center;"
                    class="inputAcc"
                    @blur="validaScontoTotale()"
                  />
                </b-col>
                <b-col v-if="$store.getters.profiloUtente.prezzi" md="3" style="text-align:right">
                  <b>
                    <input
                      v-model.number="prezzoTotaleNetto"
                      type="number"
                      class="inputAcc"
                      style="text-align:right;"
                      @blur="validaNettoTotale()"
                    />
                  </b>
                </b-col>
              </b-row>
            </b-container>
            <br />
          </span>
          <!-- REMARKS -->
          <b-container v-show="nMaxRemarks > 0">
            <b-row style="padding-left:15px">
              <b-col style="text-align:left">
                <h5>{{ uniTranslation("PHE10032") }}</h5>
              </b-col>
            </b-row>
          </b-container>
          <b-container v-show="nMaxRemarks > 0" class="bordo" style="background: white;">
            <b-row v-for="n in nMaxRemarks" class="bordo-sotto">
              <b-col style="text-align:left">
                <input v-model="remarks[n]" style="width:100%;border:none;text-align:left" />
              </b-col>
            </b-row>
          </b-container>

          <br />
          <br />
          <br />
          <br />

          <b-modal v-model="showWarning" ok-only>
            <p v-for="war in listaWarning" :key="war" v-text="uniTranslation(war)"></p>
          </b-modal>

          <b-modal
            v-model="bShowModalCambioPED"
            @ok="elaboraCambioCombo(ItemCambioPED)"
            @cancel="rispristinaCombo()"
          >
            <p>{{ uniTranslation("PHE10026") }}</p>
            <p>
              {{ ItemCambioPED.CambioPedResult.oldPED }} =>
              {{ ItemCambioPED.CambioPedResult.newPED }}
            </p>
            <p>{{ uniTranslation("PHE10027") }}</p>
            <!--
            Dim Msg As String = GetT(10026, "Attenzione! Le connessioni richieste portano a una categoria PED differente!")
            Msg = Msg & vbCrLf & vbCrLf & Sc.CIAT_CategoriaPED & " => " & NewPED
            Msg = Msg & vbCrLf & vbCrLf & GetT(10027, "Continuare?")
        -->
          </b-modal>
          <!--<Loading :active="bShowLoading" :is-full-page="true"></Loading>-->
        </b-col>
      </b-row>
    </b-overlay>
    <!-- <b-modal
      v-model="bMostraStepPiastreDialog"
      no-close-on-backdrop
      no-close-on-esc
      hide-header
      hide-footer
    >
      <b-row>
        <b-col sm="2">
          <i class="fa fa-exclamation-triangle" style="color: red" aria-hidden="true"></i>
        </b-col>
        <b-col style=" text-align: justify; text-justify: inter-word;" sm="8">
          <h5>{{ uniTranslation("TTL_POPUP_STEPPIASTRE") }}</h5>
        </b-col>
        <b-col sm="2">
          <i class="fa fa-exclamation-triangle" style="color: red" aria-hidden="true"></i>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="10"> </b-col>
        <b-col md="2">
          <b-button
            @click="bMostraStepPiastreDialog = false"
            :disabled="bShowLoading == true"
            :style="{
              backgroundColor: coloreFooterBottoni,
              borderColor: coloreBordoBottoni,
              color: coloreTestoBottoni
            }"
            block
          >
            <i class="fa-solid fa-check"></i>
          </b-button>
        </b-col>
      </b-row>
    </b-modal> -->
  </div>
</template>

<script>
import accessoriesService from "../../services/backendCipriani/accessoriesService";
import colorsService from "../../services/backend/colorsService";
import { mapGetters } from "vuex";

import projectService from "../../services/backend/projectService";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "PheAccessoriesCipriani",
  components: {
    Loading
  },
  props: {
    parentPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      stepPiastre: [],
      stepSelezionato: null,
      bStepPiastre: false,

      opzioni: [],
      accessori: [],
      backup: [],
      plateExchanger: {
        prezzo: 0,
        desc1: "",
        desc2: "",
        desc3: ""
      },
      project: null,
      prezzoExchangerListino: 0,
      prezzoAccessoriListino: 0,
      prezzoTotaleListino: 0,

      prezzoExchangerNetto: 0,
      prezzoAccessoriNetto: 0,
      prezzoTotaleNetto: 0,
      prezzoTotaleNettoCalcolato: 0,

      scontoExchanger: 0,
      scontoAccessori: 0,
      scontoTotale: 0,
      scontoCalcolato: 0,

      bShowLoading: false,

      scontoMax: 100 /* Da confermare con loro */,
      remarks: [],
      nMaxRemarks: 3,
      accSpeciali: [],
      nMaxAccSpeciali: 3,
      coloreSfondo: "",
      coloreTesto: "",
      coloreBarraTitolo: "",
      coloreTitolo: "",
      coloreSfondoTab: "",
      coloreTestoTab: "",
      coloreBordo: "",

      coloreFooterSfondo: "",
      coloreFooterTesto: "",
      coloreFooterBottoni: "",
      coloreTestoBottoni: "",
      coloreBordoBottoni: "",
      coloreBordo: "",
      bMostraStepPiastreDialog: false,

      listaWarning: [],
      showWarning: false,

      bShowModalCambioPED: false,
      ItemCambioPED: {
        CambioPedResult: { NewPED: "", OldPED: "" }
      }
    };
  },
  watch: {
    bStepPiastre() {
      var that = this;

      if (that.bStepPiastre == false) that.stepSelezionato = that.stepPiastre[0];
    },
    stepSelezionato(newValue, oldValue) {
      if (this.bStepPiastre == false || oldValue == newValue) return;
      var that = this;
      //this.$store
      //  .dispatch("changeProjectProperty", {
      //    path: that.parentPath + ".innerProject.percentualePiastreAggiuntive",
      //    //path: that.parentPath + ".CIPRIANI_PERCENTUALE_Selezionata",
      //    value: newValue.percentuale
      //  })
      //  .then(() => {
      that.projects[that.parentPath].innerProject.percentualePiastreAggiuntive =
        newValue.percentuale;
      that.bShowLoading = true;
      projectService
        .syncShoulder(that.projects)
        .then(() => {})
        .finally(() => {
          that.bShowLoading = false;
          if (oldValue != null) {
            if (newValue.percentuale != oldValue.percentuale) {
              that.bMostraStepPiastreDialog =
                oldValue.bTelaioOriginale != newValue.bTelaioOriginale;
            }

            that.backup = [];
            that.backup = that.backup.concat(that.accessori.slice());
            that.backup = that.backup.concat(that.opzioni.slice());
            that.updateFromServer();
          }
        });
      //  });
    }
  },
  computed: {
    ...mapGetters(["projects", "simboloValuta"]),

    bTelaioOriginale() {
      if (this.stepSelezionato != null) {
        return this.stepSelezionato.bTelaioOriginale;
      }

      return false;
    },

    tradNrPiastreSuMassimo() {
      var trad = this.uniTranslation("TTL_NRPIASTRESU");

      if (this.stepSelezionato == null || this.stepSelezionato == undefined) return;

      trad = trad.replace("$value$", this.stepSelezionato.nrPiastre);
      trad = trad.replace("$max$", this.stepSelezionato.maxPiastre);

      return trad;
    }
  },
  mounted: function() {
    var that = this;

    //colorsService.getColoriCard().then(function(data) {
    var colorList = colorsService.getColoriCard();
    that.coloreSfondo = colorList[0] + " !important"; // 7 elementi. 0=sfondo 1=barra titolo 2=testo 3=colore titolo 4= sfondo tab 5=testo tab 6=testo titolo tab quando selezionata
    that.coloreBarraTitolo = colorList[1];
    that.coloreTesto = colorList[2];
    that.coloreTitolo = colorList[3];
    that.coloreSfondoTab = colorList[4];
    that.coloreTestoTab = colorList[5];
    that.coloreBordo = colorList[6];

    var colorList = colorsService.getColoriFooter();
    //that.coloriFooter = colorList; // 3 elementi 0=sfondo 1=testo 2=bottoni
    that.coloreFooterSfondo = colorList[0];
    that.coloreFooterTesto = colorList[1];
    that.coloreFooterBottoni = colorList[2] + " !important";
    that.coloreTestoBottoni = colorList[3];
    that.coloreBordoBottoni = colorList[4];
    that.coloreBordo = colorList[5];

    //});
    if (this.$store.getters.profiloUtente) {
      this.nMaxRemarks = this.$store.getters.profiloUtente.nmaX_RigheR;
      this.nMaxAccSpeciali = this.$store.getters.profiloUtente.nmaX_RigheA;
    }

    if (that.parentPath) {
      that.project = that.projects[that.parentPath];

      this.updateFromServer();
      that.$store.subscribe(function(mutation /*, state*/) {
        if (mutation.type === "loadProject") {
          that.project = that.projects[that.parentPath];
        }
      });
    }
  },
  methods: {
    updateFromServer: function() {
      var that = this;
      that.bShowLoading = true;
      var showStep = JSON.parse(JSON.stringify(that.bMostraStepPiastreDialog));
      that.bMostraStepPiastreDialog = false;
      projectService.syncShoulder(that.projects).then(() => {
        accessoriesService.getModelOpzioniAccessori(that.project).then(function(data) {
          that.opzioni = [];
          that.accessori = [];
          that.stepPiastre = [];

          that.plateExchanger = { prezzo: 0, desc1: "", desc2: "", desc3: "" };

          //console.log(that.backup);
          data.forEach(x => {
            var old = that.backup.find(bck => bck.code == x.code);
            //console.log(x);
            if (old != null) {
              x.ckd = old.ckd;
            }

            if (x.tipoElemento == "MODEL") that.plateExchanger = x;

            if (x.tipoElemento == "OPT") that.opzioni.push(x);

            if (x.tipoElemento == "ACC") that.accessori.push(x);

            if (x.tipoElemento == "STEP_PIASTRE") that.stepPiastre.push(x);
          });
          that.bStepPiastre = that.bStepPiastre && that.stepPiastre.length > 0;
          if (that.stepPiastre.length > 0 && that.stepSelezionato == null) {
            var perc = that.project.innerProject.percentualePiastreAggiuntive;

            perc = perc == undefined ? 0 : perc;

            var bEsiste = that.stepPiastre.some(step => step.percentuale == perc);

            console.log(bEsiste);
            if (bEsiste == true) {
              that.stepSelezionato = that.stepPiastre.find(step => step.percentuale == perc);
            } else {
              that.stepSelezionato = that.stepPiastre[that.stepPiastre.length - 1];
            }
            that.bStepPiastre = that.stepSelezionato.percentuale > 0;
          }

          that.AggiornaTotali();

          that.bShowLoading = false;
          that.bMostraStepPiastreDialog = showStep;
        });
      });
    },

    findWarning(lista) {
      var that = this;
      lista.forEach(x => {
        if ("" + x.warning != "") {
          that.listaWarning.push(x.warning);
        }
      });
    },

    controllaWarning() {
      this.listaWarning = [];
      this.showWarning = false;

      this.findWarning(this.opzioni);
      this.findWarning(this.accessori);

      this.showWarning = this.listaWarning.length > 0;
    },

    SelectedCombo(item) {
      var x = {
        calculationId: this.project.calculationId,
        item: item
      };

      this.controlloPED(x);
    },

    rispristinaCombo() {
      var that = this;

      var cpr = this.ItemCambioPED.CambioPedResult;
      var code = this.ItemCambioPED.item.code;

      this.opzioni.forEach(function(xO, index) {
        if (xO.code == code) {
          that.opzioni[index].valoreSelezionato = cpr.oldValue;
        }
      });
    },

    controlloPED(item) {
      var that = this;
      accessoriesService.checkCambioPed(item).then(function(data) {
        item.CambioPedResult = data;

        if (data.bChanged) {
          that.ItemCambioPED = item;
          that.bShowModalCambioPED = true;
        } else {
          that.elaboraCambioCombo(item);
        }
      });
    },

    elaboraCambioCombo(item) {
      var that = this;
      accessoriesService.postOpzioneComboItemChange(item).then(function(data) {
        data.forEach(a => {
          if (a.code == "Model") {
            that.plateExchanger = a;
          }
          if (a.code == "eOpzione.Collettori") {
            that.opzioni.forEach(function(xO, index) {
              if (xO.code == "eOpzione.Collettori") {
                that.opzioni[index] = a;
              }
            });
          }
          that.controllaWarning();

          /*
            Antonio C
            21/07/2020
          */
          that.AggiornaTotali();
        });
      });
    },

    controllaTesto(testo) {
      var that = this;
      var xt = testo.split("@:");
      var x = ""; //uniTranslation(x)
      xt.forEach(e => {
        x = x + " " + that.uniTranslation(e);
      });
      return x;
    },

    rimuoviSpuntaTirante(lista, code) {
      lista.forEach(x => {
        if (x.tirante && x.code != code) {
          x.ckd = false;
        }
      });
    },

    aggiornaPrezzoAccessori: function(item) {
      if (item.tirante) {
        this.rimuoviSpuntaTirante(this.opzioni, item.code);
        this.rimuoviSpuntaTirante(this.accessori, item.code);
      }

      this.AggiornaTotali();
    },

    AggiornaTotali() {
      var that = this;
      var xInvia = this.getDatiAccessori();
      accessoriesService.getNewModelName(xInvia).then(function(data) {
        if (data) {
          that.plateExchanger = data;
        }
      });

      var totA = 0;
      /*this.opzioni.forEach(o => {
        if (!o.prezzoincluso) if (o.ckd) totA += o.prezzo;
      });

      this.accessori.forEach(a => {
        if (!a.prezzoincluso) if (a.ckd) totA += a.prezzo;
      });*/

      for (const o of this.opzioni) {
        if (!o.prezzoincluso) if (o.ckd) totA += o.prezzo;
      }

      for (const a of this.accessori) {
        if (!a.prezzoincluso) if (a.ckd) totA += a.prezzo;
      }

      this.prezzoExchangerListino = this.plateExchanger.prezzo;
      this.prezzoAccessoriListino = totA;
      this.prezzoTotaleListino = this.prezzoExchangerListino + this.prezzoAccessoriListino;
      this.sistemaSconti();
    },

    getDatiAccessori() {
      var xInvia = {
        calculationId: this.project.calculationId,
        xLista: [],
        scontoExchanger: this.scontoExchanger,
        scontoAccessori: this.scontoAccessori,
        scontoTotale: this.scontoTotale,
        remarks: []
      };

      this.opzioni.forEach(x => {
        xInvia.xLista.push(x);
      });
      this.accessori.forEach(x => {
        xInvia.xLista.push(x);
      });
      this.remarks.forEach(x => {
        xInvia.remarks.push(x);
      });
      /*accessoriesService.postRemarks({
        riga1: this.remarks[0],
        riga2: this.remarks[1],
        riga3: this.remarks[2]
      });*/

      return xInvia;
    },

    salvaDati() {
      var xInvia = this.getDatiAccessori();
      return accessoriesService.postOpzioniAccessori(xInvia);
    },

    validaScontoAccessori() {
      if (Number.isNaN(parseFloat(this.scontoAccessori))) {
        this.scontoAccessori = 0;
      }
      this.scontoAccessori = Math.max(
        Math.min(parseFloat(this.scontoAccessori), this.scontoMax),
        0
      );
      this.sistemaSconti();
    },
    validaScontoExchanger() {
      if (Number.isNaN(parseFloat(this.scontoExchanger))) {
        this.scontoExchanger = 0;
      }
      this.scontoExchanger = Math.max(
        Math.min(parseFloat(this.scontoExchanger), this.scontoMax),
        0
      );
      this.sistemaSconti();
    },

    validaScontoTotale() {
      if (this.scontoCalcolato != this.scontoTotale) {
        this.scontoAccessori = Math.max(Math.min(parseFloat(this.scontoTotale), this.scontoMax), 0);
        this.scontoExchanger = Math.max(Math.min(parseFloat(this.scontoTotale), this.scontoMax), 0);
        this.sistemaSconti();
      }
    },

    calcolaSconto(L, N) {
      var s = 0;
      if (L != 0) s = (1 - N / L) * 100;

      return s;
    },

    validaNettoAccessori() {
      this.scontoAccessori = this.calcolaSconto(
        this.prezzoAccessoriListino,
        this.prezzoAccessoriNetto
      );
      this.validaScontoAccessori();
    },

    validaNettoExchanger() {
      this.scontoExchanger = this.calcolaSconto(
        this.prezzoExchangerListino,
        this.prezzoExchangerNetto
      );

      this.validaScontoExchanger();
    },

    validaNettoTotale() {
      if (this.prezzoTotaleNettoCalcolato != this.prezzoTotaleNetto) {
        this.scontoTotale = this.calcolaSconto(this.prezzoTotaleListino, this.prezzoTotaleNetto);
        this.validaScontoTotale();
      }
    },

    sistemaSconti() {
      this.prezzoExchangerNetto = this.prezzoExchangerListino * (1 - this.scontoExchanger / 100);
      this.prezzoAccessoriNetto = this.prezzoAccessoriListino * (1 - this.scontoAccessori / 100);
      this.prezzoTotaleNetto = this.prezzoExchangerNetto + this.prezzoAccessoriNetto;

      var s = this.calcolaSconto(this.prezzoTotaleListino, this.prezzoTotaleNetto);
      this.scontoTotale = this.arrotonda2dec(s);
      this.scontoCalcolato = this.arrotonda2dec(s);
      this.scontoExchanger = this.arrotonda2dec(this.scontoExchanger);
      this.scontoAccessori = this.arrotonda2dec(this.scontoAccessori);

      this.prezzoExchangerNetto = this.arrotonda2dec(this.prezzoExchangerNetto);

      this.prezzoAccessoriNetto = this.arrotonda2dec(this.prezzoAccessoriNetto);
      this.prezzoTotaleNetto = this.arrotonda2dec(this.prezzoTotaleNetto);
      this.prezzoTotaleNettoCalcolato = this.prezzoTotaleNetto;
    },

    arrotonda2dec(s) {
      s = Math.round(s * 100);
      return s / 100;
    }
  }
};
</script>

<style>
.inputAcc {
  width: 100%;
  border: none;
  text-align: center;
  background-color: unset;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

a {
  color: black;
}

.card-header {
  padding: 0px;
}

.card-body {
  padding: 0px;
}

.card {
  border: unset;
}

.bordo-dx {
  border-right: solid;
  border-right-color: #cccccc;
  border-right-width: 1px;
}

.bordo-sotto {
  border-bottom: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
}
.om {
  border-bottom: solid;
  border-bottom-color: #cccccc;
  border-bottom-width: 1px;
  padding: 13px 0px;
}
.bordo {
  border: solid;
  border-width: 1px;
}

p {
  margin-bottom: 0rem;
}
</style>
